var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7657 14.8845H20.3054C19.64 14.8845 19.0499 15.2967 18.8459 15.9063C18.305 17.5188 16.7588 18.6012 15.0002 18.6012C13.241 18.6012 11.6954 17.5188 11.1548 15.9063C10.9502 15.2967 10.3607 14.8845 9.6947 14.8845H4.2347C3.3872 14.8845 2.7002 15.5445 2.7002 16.3602V24.7764C2.7002 25.5906 3.3872 26.2515 4.2347 26.2515H25.766C26.6141 26.2515 27.3002 25.5906 27.3002 24.7764V16.3602C27.2999 15.5445 26.6135 14.8845 25.7657 14.8845Z",
    fill: "#556EE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.743 10.2828H12.7389V15.4392C12.7389 15.6597 12.924 15.837 13.1517 15.837H16.8468C17.0754 15.837 17.2596 15.6597 17.2596 15.4392V10.2828H19.257C19.4112 10.2828 19.5528 10.1991 19.6233 10.068C19.6582 10.0036 19.6739 9.93052 19.6685 9.85745C19.663 9.78439 19.6368 9.71441 19.5927 9.65584L15.3216 3.91444C15.2824 3.86267 15.2316 3.82073 15.1733 3.79194C15.1151 3.76315 15.0509 3.74829 14.9859 3.74854H14.985C14.8515 3.74854 14.7273 3.81064 14.6493 3.91594L10.4058 9.65614C10.3623 9.71496 10.3364 9.78492 10.3311 9.85789C10.3258 9.93086 10.3413 10.0038 10.3758 10.0683C10.4463 10.2006 10.5888 10.2828 10.743 10.2828Z",
    fill: "#556EE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.0e67aa5c358f08059e6a5e5dbd417677.svg";
export { ForwardRef as ReactComponent };